<template>
  <div>
    <v-row dense class="mx-1">
      <v-spacer/>
      <v-btn v-if="hasFilters"
             small
             text
             class="normal-btn-text rounded-tag-small mt-1"
             @click="clearFilters">
        Limpar filtros
        <v-icon right small color="error">mdi-close</v-icon>
      </v-btn>
      <v-btn icon @click="onClickRefresh">
        <v-icon left>mdi-refresh</v-icon>
      </v-btn>
      <px-listagem-aprovacao-solicitacao-filtros ref="filtros" @change="emitChange"/>
      <px-search-text class="rounded-tag-small"
                      label="Busque por solicitante, empresa ou identificador"
                      v-model="searchText"
                      style="max-width: 400px"
                      :on-search="emitChange"/>
    </v-row>
    <px-line-filter :options="statusOptions" v-model="selectedStatus"
                    :on-select-item="emitChange">
    </px-line-filter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListagemAprovacaoSolicitacaoFiltros
  from '@/modules/aprovacao-solicitacao/ListagemAprovacaoSolicitacaoFiltros.vue';

export default {
  data() {
    return {
      statusOptions: [
        {
          id: 'TODAS',
          description: 'Todas',
          value: null,
        },
        {
          id: 'PENDENTES',
          description: 'Pendentes',
          value: 'PENDENTE',
        },
        {
          id: 'APROVADAS',
          description: 'Aprovadas',
          value: 'APROVADO',
        },
        {
          id: 'RECUSADAS',
          description: 'Recusadas',
          value: 'RECUSADO',
        },
      ],
    };
  },
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
    clearFilters() {
      this.searchText = null;
      this.$refs.filtros.clearFilters();
    },
  },
  computed: {
    ...mapGetters('listagemAprovacaoSolicitacao', ['hasCustomFilters']),
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleRequisicao']),
    selectedStatus: {
      get() {
        return this.$store.getters['listagemAprovacaoSolicitacao/selectedStatus'];
      },
      set(selectedStatus) {
        this.$store.dispatch('listagemAprovacaoSolicitacao/selectedStatus', selectedStatus);
      },
    },
    searchText: {
      get() {
        return this.$store.getters['listagemAprovacaoSolicitacao/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemAprovacaoSolicitacao/searchText', searchText);
      },
    },
    hasFilters() {
      return this.hasCustomFilters || this.searchText;
    },
  },
  created() {
    if (!this.selectedStatus) {
      this.selectedStatus = this.statusOptions.find(option => option.id === 'PENDENTES');
    }
  },
  components: {
    pxListagemAprovacaoSolicitacaoFiltros: ListagemAprovacaoSolicitacaoFiltros,
  },
};
</script>
